<template>
	
	
	<div class="footer "><!-- footer -->
			<div class="w1"><!-- w1 -->
				<div class="footer_kouhao"></div>
				<div class="group1 fo_group">
					<div class="group1_L ">
						
							<div class="group1">
								<div class="group1_L">
									<dl class="fo_list">
										<dt>关于中经专网</dt>
										<dd>
											<li><a href="/pdf/Company Profile.pdf" target="_blank">公司简介</a></li>
											<li><a href="/pdf/Product Introduction.pdf" target="_blank">产品介绍</a></li>
											<li><a href="/pdf/Product Manuals.pdf" target="_blank">使用手册</a></li>
											<li><a @click="showVideoDialog()">操作视频</a></li>
										</dd>
									</dl>
								</div>
								<div class="group1_L">
									<dl class="fo_list">
										<dt>产品矩阵</dt>
										<dd>
											<li><a href='http://reportnew.cei.cn/' target="_blank" >行业发展报告库</a></li>
											<li><a href='https://region.cei.cn/' target="_blank" >区域监测评价系统</a></li>
											<li><a href='https://ceidata.cei.cn/' target="_blank" >中经数据</a></li>
											<li><a href='http://vodgov.cei.cn/' target="_blank" >中经视频</a></li>
										</dd>
									</dl>
								</div>
								<div class="group1_L">
									<dl class="fo_list">
										<dt>联系我们</dt>
										<dd>
											<li>客户服务：010-68558322&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;market@cei.cn</li>
											<li>内容咨询：010-68140963&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;region@cei.cn</li>
											<!-- <li>E-mail：market@cei.cn，region@cei.cn</li> -->
											<li>地址：北京市西城区三里河路58号 国家信息中心</li>
											<li>分部地址：北京市西城区广安门内大街315号信息大厦</li>
										</dd>
									</dl>
								</div>
							</div>
						
						
						
					</div>
					<div class="group1_R" style="margin-left: 0px;">
						<ul class="scan_code">
							<li><img src="/images/ma_gzh.jpg"  alt=""></li>
							<li>公众号</li>
						</ul>
						<ul class="scan_code">
							<li><img src="/images/ma_xcx.jpg"  alt=""></li>
							<li>小程序</li>
						</ul>
					</div>
				</div>
				
				
				<div class="group1" style="margin-top: 20px;">
					<div class="group1_L">
						<img src="/images/icon-shiyedanwei.png" style="margin-right: 18px;" />
						<span style="font-size: 14px;line-height: 62px;">国家信息中心 中经网数据有限公司 版权所有</span>
					</div>
					<div class="group1_L">
						<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009705" target="_blank">
							<img src="/images/icon-beian.png" style="margin-right: 18px;" />
							<span style="font-size: 14px;line-height: 62px;">京公网安备11010202009705号</span>
						</a>
					</div>
					<div class="group1_L">
						<a href="https://beian.miit.gov.cn" target="_blank">
							<img src="/images/icon-jingshen.png" style="margin-right: 18px;" />
							<span style="font-size: 14px;line-height: 62px;">京ICP证000069号</span>
						</a>
					</div>
					<div class="group1_L">
						<span style="font-size: 14px;line-height: 62px;">建议分辨率1366 * 768以上，推荐谷歌浏览器</span>
					</div>
				</div>
				
			</div><!-- /w1 -->
			
			
			<el-dialog :visible.sync="dialogVideoVisible" :close-on-click-modal="true" :close-on-press-escape="false" @close="pauseVideo()">
			  <video id="manualsVideo" style="width:100%;margin-bottom: -6px;" controls controlsList="nodownload">
					<source src="/pdf/Product Manuals Video.mov" type="video/mp4">
					您的浏览器不支持播放此视频
				</video>
			</el-dialog>
			
		</div>
</template>

<script>
	export default {
		data() {
			return{
				dialogVideoVisible:false,
			}
		},
		methods: {
			showshiyong:function(){
				this.$emit('showshiyong');
			},
			showVideoDialog:function(){
				this.dialogVideoVisible=true;
			},
			pauseVideo:function(){
				var myVideo=document.getElementById('manualsVideo');
				myVideo.pause();
			},
		}
	}
</script>

<style>
</style>
